import React, { forwardRef } from 'react';
import {
  IconButton,
  Input,
  InputGroup,
  InputProps,
  InputRightElement,
  useTheme,
} from '@chakra-ui/react';
import { ForwardRefComponent } from 'framer-motion';
import { InputPropsType } from '../Form.types';
import { OmitProps } from '../../utils/OmitProps';

const InputPswWithOmittedProps = OmitProps(Input, ['fieldState', 'formState']);

export const InputPsw: ForwardRefComponent<
  InputPropsType & InputProps,
  InputPropsType & InputProps
> = forwardRef(({ size = 'md', value, name, ...props }, ref) => {
  const [show, setShow] = React.useState(false);
  const handleClick = () => setShow(!show);
  const theme = useTheme();
  return (
    <InputGroup size={size}>
      <InputPswWithOmittedProps
        pr="4.5rem"
        type={show ? 'text' : 'password'}
        id={name}
        {...props}
        value={value || ''}
        ref={ref}
      />
      <InputRightElement mr={3}>
        <IconButton
          variant="ghost"
          icon={
            show ? <theme.icons.IcVisibilityNo /> : <theme.icons.IcVisibility />
          }
          size={size}
          onClick={handleClick}
          aria-label={show ? 'Hide' : 'Show'}
          minW={'auto'}
        />
      </InputRightElement>
    </InputGroup>
  );
});
